import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { C, F } from '../landingTheme';
import { pricingFaq } from './pricingCopy';

export default function PricingFaq({ data }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="mt-20 max-w-3xl mx-auto" data-testid="pricing-faq">
      <h3 className="text-2xl md:text-3xl font-extrabold text-center" style={{ fontFamily: F.display, color: C.ink, letterSpacing: '-0.03em' }}>Pricing questions</h3>
      <div className="mt-8 divide-y rounded-2xl border bg-white" style={{ borderColor: C.border }}>
        {pricingFaq(data).map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q} style={{ borderColor: C.border }}>
              <button onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} data-testid={`pricing-faq-q-${i}`}
                className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left">
                <span className="font-semibold" style={{ fontFamily: F.display, color: C.ink }}>{item.q}</span>
                <Plus className="w-4 h-4 shrink-0 transition-transform duration-300" strokeWidth={2.5}
                  style={{ color: C.saffron, transform: isOpen ? 'rotate(45deg)' : 'none' }} />
              </button>
              <div className="grid transition-[grid-template-rows] duration-300" style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}>
                <div className="overflow-hidden">
                  <p className="px-5 sm:px-6 pb-5 text-sm leading-relaxed" style={{ fontFamily: F.body, color: C.ink2 }} data-testid={`pricing-faq-a-${i}`}>{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
